import { Space, Table, Tooltip } from 'antd';
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { useCallback, useEffect, useState } from 'react';
import useDebounce from '@you-go-vn/components/hooks/useDebounce';
import SaleIcon from '@you-go-vn/components/src/Common/Icons/SaleIcon';
import FreeShipIcon from '@you-go-vn/components/src/Common/Icons/FreeShipIcon';
import LogoIcon from '@you-go-vn/components/src/Common/Icons/LogoIcon';

import { PromotionDetail } from '../../data';
import { useAppSelector } from '../../../../store';
import { yougoPromotionServices } from '../services';
import { addCommaToNumber } from '@you-go-vn/components';
import { promotionDiscountTargets, promotionTypes } from '../..';
import DetailModal from '../../components/DetailModal';

const initPagination: TablePaginationConfig = {
  current: 1,
  pageSize: 10,
  total: 0,
};

type Props = {
  searchInput: string;
};
const TabJoined = ({ searchInput }: Props) => {
  const { currentRestaurant } = useAppSelector((s) => s.restaurant);
  const [data, setData] = useState<PromotionDetail[]>([]);
  const [pagination, setPagination] = useState(initPagination);

  const [loadingTable, setLoadingTable] = useState(true);
  const [currentRow, setCurrentRow] = useState<PromotionDetail>();

  const [detailModalVisible, setDetailModalVisible] = useState(false);

  const fetchTable = useCallback(
    ({ value = '', pagination = initPagination }) => {
      setLoadingTable(true);
      yougoPromotionServices
        .getYougoPromotionsRestaurantJoined(currentRestaurant?.id, {
          page: pagination.current,
          limit: pagination.pageSize,
          keywords: value ? value : undefined,
        })
        .then(async ({ data }) => {
          if (data.data) {
            const items = data.data.items;
            setData(items);
            setPagination({
              ...pagination,
              total: data.data.total,
            });
            setLoadingTable(false);
          }
        });
    },
    [currentRestaurant],
  );

  const search = useDebounce(fetchTable);

  useEffect(() => {
    search(searchInput);
  }, [search, searchInput]);

  const columns: ColumnsType<PromotionDetail> = [
    {
      title: 'Tên',
      dataIndex: 'name',
      render: (_, record) => (
        <Space>
          <Tooltip
            title={
              promotionTypes.find((x) => x.value === record.type)?.label ||
              'Chưa cập nhật'
            }
          >
            <div>
              {record.type === 'yougofood' && (
                <LogoIcon style={{ fontSize: 40 }} />
              )}
              {record.type === 'yougobike' && 'YouGo Bike'}
              {record.type === 'yougoship' && 'YouGo Ship'}
            </div>
          </Tooltip>
          <span>{record.name}</span>
        </Space>
      ),
    },
    {
      title: 'Mã khuyến mãi',
      dataIndex: 'code',
      // responsive: ['xl'],
    },
    { title: 'Mô tả', dataIndex: 'description', responsive: ['xl'] },
    {
      title: 'Giảm giá',
      align: 'right',
      // responsive: ['lg'],
      render: (_, record) => (
        <Space>
          <span>
            {addCommaToNumber(record.discountAmount)}
            {record.discountType === 'fixed_amount' ? ' VNĐ' : ' %'}
          </span>
          <Tooltip
            title={
              promotionDiscountTargets.find(
                (x) => x.value === record.discountTarget,
              )?.label || 'Chưa cập nhật'
            }
          >
            {record.discountTarget === 'base_total' ? (
              <SaleIcon style={{ fontSize: 40, color: 'red' }} />
            ) : (
              <FreeShipIcon style={{ fontSize: 40, color: 'yellowgreen' }} />
            )}
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table<PromotionDetail>
        columns={columns}
        rowKey={(record) => record.id}
        dataSource={data}
        pagination={pagination}
        loading={loadingTable}
        onChange={(pagination) => {
          fetchTable({ pagination, value: searchInput });
        }}
        onRow={(record) => {
          return {
            onClick: () => {
              setCurrentRow(record);
              setDetailModalVisible(true);
            },
          };
        }}
      />
      {currentRow && (
        <DetailModal
          visible={detailModalVisible}
          initialValues={currentRow}
          onCancel={() => {
            setDetailModalVisible(false);
            setCurrentRow(undefined);
          }}
          actions={null}
        />
      )}
    </>
  );
};
export default TabJoined;
